module.exports = __webpack_public_path__ + "static/media/company-details.0b7af03e.svg";